import { render } from "./Remove.vue?vue&type=template&id=6b9b2feb&scoped=true"
import script from "./Remove.vue?vue&type=script&lang=js"
export * from "./Remove.vue?vue&type=script&lang=js"

import "./Remove.vue?vue&type=style&index=0&id=6b9b2feb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9b2feb"]])

export default __exports__